/**
 * Point d'entrée. En mode simulation (par défaut), démarre MSW + IndexedDB AVANT de monter l'application.
 * En mode réel (VITE_API_MODE=real), aucun code de simulation n'est importé (exclu du bundle — vérifié en CI).
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@myron/design-system/styles.css';
import { App } from './app/App';

async function demarrer() {
  if (import.meta.env.VITE_API_MODE !== 'real') {
    const { startSimulation } = await import('@myron/mocks/browser');
    await startSimulation();
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
void demarrer();
